import { gql } from "@apollo/client";

const LEAGUE_BY_ID = gql`
  query ($id: ID, $publicId: String, $gender: String) {
    league(id: $id, publicId: $publicId, gender: $gender) {
      id
      title
      country
      type
      enableRankings
      enableLicense
      enableOnlinePayments
      isFeatured
      status
      isDefault
      platform {
        id
        publicId
      }
      sports {
        id
        title
        resourceTitle
        sportType
        footballLineupEnabled
        footballAdvancedMatchDetailsEnabled
        footballGroupStandingsEnabled
        footballLiveStandingsEnabled
        discipline {
          id
          title
        }
      }

      email
      website
      phone
      instagram
      abbreviation
      priority
      license
      discipline
      logo
      abbreviationLogo
      bannerCover
      globalCategoryLimitPerPlayer

      factSheet {
        id
        fieldTitle
        fieldType
        options
      }
      members {
        member {
          email
        }
      }
      owner {
        federation {
          id
          publicId
          user {
            id
          }
        }
      }
      leagueCategory {
        category {
          id
          name
          type
          gender
          uniqueCode
          maxTournaments
          activeFrom
          activeTo
          sort
          ageLimit
          ageLimitType
          selectStage
          countries
        }
      }
      allowUnregisteredPlayers
      requireTournamentApproval
      liveStreaming_sporfie_key
      tournatedFeeVat
      isTournatedFeeVatEnable
      isCustomFeeEnable
      customFee {
        id
        rangeStart
        rangeEnd
        feeType
        currency
        serviceType
        feeMode
        isMonetization
        isManagerPayingServiceFee
        tournatedFee
        partnerFee
        tournatedMinFee
        tournatedMaxFee
        partnerMinFee
        partnerMaxFee
        tournatedMinPercentageFee
        tournatedMaxPercentageFee
        partnerMinPercentageFee
        partnerMaxPercentageFee
      }
    }
  }
`;

export default LEAGUE_BY_ID;
